import React from 'react';
import { PriceContainer, PriceDetailWrapper } from '../styles/ConversionBar.styles';
import {
  FootnoteReference,
  needsCurrencyFormatting,
  PriceItem,
  useServicesContext,
} from '@oneaudi/vtp-shared';
import { NumberFormatterServiceV1 } from '@oneaudi/number-formatter-service/dist/v1';
import { Text } from '@oneaudi/unified-web-components';

interface DisplayConversionbarPriceProps {
  priceConfig: PriceItem;
  isColumn: boolean;
}

export const DisplayConversionbarPrice: React.FC<DisplayConversionbarPriceProps> = ({
  priceConfig,
  isColumn,
}) => {
  const formatter = useServicesContext().getAdditionalService(
    'audi-number-formatter-service'
  ) as NumberFormatterServiceV1;

  const formattedPrice = needsCurrencyFormatting(priceConfig?.price)
    ? formatter.formatCurrency(Number(priceConfig?.price))
    : priceConfig?.price;

  return (
    <PriceDetailWrapper data-testid="display-priceWrapper">
      <PriceContainer isColumn={isColumn}>
        <Text tag="p" variant={{ type: 'copy', order: '2', style: 'normal' }}>
          {priceConfig?.label}
        </Text>

        <Text tag="p" variant={{ type: 'copy', order: '1', style: 'bold' }}>
          {formattedPrice}
          {priceConfig?.priceFootnote && <FootnoteReference refId={priceConfig?.priceFootnote} />}
        </Text>
      </PriceContainer>
    </PriceDetailWrapper>
  );
};
